import { generatePath } from 'react-router';
import { paths } from '../../../common/constants/pathVariables.js';
import {
  billingAccountExtensionNameMsg,
  payerDetailsMsg,
  payerMsg,
  referenceMsg,
  t,
} from '../../../common/i18n/index.js';
import { getDeliveryMethodDisplayValue } from '../../../common/utils/billingAccountUtils.js';
import { SearchResultRow } from '../SearchResultRow.js';
import { HeaderSectionContent, SectionContent } from '../SectionContent.js';
import { getResultObjectWithHighlightedValues } from '../highlightFunctions.js';
import type { BillingAccountHeader } from '../../../generated/api/billingAccountHeader.js';
import type { SearchResultBaseProps } from '../SearchResultRow.js';

export interface BillingAccountProps extends SearchResultBaseProps {
  billingAccount: BillingAccountHeader;
}

export const BillingAccount = ({ billingAccount, matchedFields, searchTerms, ...rest }: BillingAccountProps) => {
  const {
    billingContactName,
    billingAccountName,
    billingAccountDisplayId,
    billingAccountExtensionName,
    payerName,
    customerReference1,
    customerReference2,
    customerReference3,
    customerReference4,
    payerNameExtension,
  } = getResultObjectWithHighlightedValues(
    // @ts-ignore
    billingAccount,
    matchedFields,
    searchTerms
  );
  return (
    <SearchResultRow
      icon="draft"
      upperSection={<HeaderSectionContent left={billingAccountDisplayId} right={billingAccountName} />}
      lowerSection={
        <SectionContent
          left={
            billingContactName && (
              <>
                {t.VYZS('Contact person')}: {billingContactName}
              </>
            )
          }
          right={getDeliveryMethodDisplayValue(billingAccount.deliveryMethod!)}
        />
      }
      additionalHighlightableFields={[
        {
          title: t.KUTS(billingAccountExtensionNameMsg),
          value: billingAccountExtensionName,
          key: 'billingAccountExtensionName',
        },
        { title: t.PB6S(payerMsg), value: payerName, key: 'payerName' },
        { title: t.YLAI(payerDetailsMsg), value: payerNameExtension, key: 'payerNameExtension' },
        { title: `${t.LVRN(referenceMsg)} 1`, value: customerReference1, key: 'customerReference1' },
        { title: `${t.LVRN(referenceMsg)} 2`, value: customerReference2, key: 'customerReference2' },
        { title: `${t.LVRN(referenceMsg)} 3`, value: customerReference3, key: 'customerReference3' },
        { title: `${t.LVRN(referenceMsg)} 4`, value: customerReference4, key: 'customerReference4' },
      ]}
      matchedFields={matchedFields}
      linkHref={`${generatePath(paths.BILLING_ACCOUNT, { billingAccountId: billingAccount.billingAccountDisplayId! })}?mdmId=${billingAccount.accountMasterId}`}
      {...rest}
    />
  );
};
